export const FormatsData: {[k: string]: SpeciesFormatsData} = {
	charizard: {
		tier: "UU",
		doublesTier: "DOU",
	},
	raichu: {
		tier: "RU",
		doublesTier: "DOU",
	},
	raichualola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	wigglytuff: {
		tier: "UU",
		doublesTier: "DOU",
	},
	venomoth: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dugtrio: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dugtrioalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	persian: {
		tier: "RU",
		doublesTier: "DOU",
	},
	persianalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	perrserker: {
		tier: "UU",
		doublesTier: "DOU",
	},
	golduck: {
		tier: "RU",
		doublesTier: "DOU",
	},
	primeape: {
		tier: "RU",
		doublesTier: "DOU",
	},
	annihilape: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arcanine: {
		tier: "RU",
		doublesTier: "DOU",
	},
	arcaninehisui: {
		tier: "UU",
		doublesTier: "DOU",
	},
	slowbro: {
		tier: "UU",
		doublesTier: "DOU",
	},
	slowbrogalar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	slowking: {
		tier: "UU",
		doublesTier: "DOU",
	},
	slowkinggalar: {
		tier: "OU",
		doublesTier: "DOU",
	},
	magneton: {
		tier: "RU",
		doublesTier: "DOU",
	},
	magnezone: {
		tier: "OU",
		doublesTier: "DOU",
	},
	muk: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mukalola: {
		tier: "UU",
		doublesTier: "DOU",
	},
	cloyster: {
		tier: "RU",
		doublesTier: "DOU",
	},
	haunter: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gengar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hypno: {
		tier: "RU",
		doublesTier: "DOU",
	},
	electrode: {
		tier: "RU",
		doublesTier: "DOU",
	},
	electrodehisui: {
		tier: "RU",
		doublesTier: "DOU",
	},
	chansey: {
		tier: "RU",
		doublesTier: "DOU",
	},
	blissey: {
		tier: "UU",
		doublesTier: "DOU",
	},
	scyther: {
		tier: "UU",
		doublesTier: "DOU",
	},
	scizor: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kleavor: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tauros: {
		tier: "RU",
		doublesTier: "DOU",
	},
	taurospaldeacombat: {
		tier: "RU",
		doublesTier: "DOU",
	},
	taurospaldeablaze: {
		tier: "UU",
		doublesTier: "DOU",
	},
	taurospaldeaaqua: {
		tier: "UU",
		doublesTier: "DOU",
	},
	gyarados: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ditto: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vaporeon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	jolteon: {
		tier: "OU",
		doublesTier: "DOU",
	},
	flareon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	espeon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	umbreon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	leafeon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	glaceon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sylveon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	articuno: {
		tier: "RU",
		doublesTier: "DOU",
	},
	articunogalar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	zapdos: {
		tier: "OU",
		doublesTier: "DOU",
	},
	zapdosgalar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	moltres: {
		tier: "UU",
		doublesTier: "DOU",
	},
	moltresgalar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dragonite: {
		tier: "OU",
		doublesTier: "DOU",
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	mew: {
		tier: "UU",
		doublesTier: "DOU",
	},
	typhlosion: {
		tier: "RU",
		doublesTier: "DOU",
	},
	typhlosionhisui: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ampharos: {
		tier: "RU",
		doublesTier: "DOU",
	},
	azumarill: {
		tier: "UU",
		doublesTier: "DOU",
	},
	sudowoodo: {
		tier: "RU",
		doublesTier: "DOU",
	},
	jumpluff: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sunflora: {
		tier: "RU",
		doublesTier: "DOU",
	},
	quagsire: {
		tier: "UU",
		doublesTier: "DOU",
	},
	clodsire: {
		tier: "UU",
		doublesTier: "DOU",
	},
	honchkrow: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mismagius: {
		tier: "RU",
		doublesTier: "DOU",
	},
	girafarig: {
		tier: "RU",
		doublesTier: "DOU",
	},
	farigiraf: {
		tier: "RU",
		doublesTier: "DOU",
	},
	forretress: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dudunsparce: {
		tier: "RU",
		doublesTier: "DOU",
	},
	qwilfish: {
		tier: "RU",
		doublesTier: "DOU",
	},
	overqwil: {
		tier: "UU",
		doublesTier: "DOU",
	},
	heracross: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sneasel: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sneaselhisui: {
		tier: "RU",
		doublesTier: "DOU",
	},
	weavile: {
		tier: "OU",
		doublesTier: "DOU",
	},
	sneasler: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ursaring: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ursaluna: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ursalunabloodmoon: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	delibird: {
		tier: "RU",
		doublesTier: "DOU",
	},
	houndoom: {
		tier: "RU",
		doublesTier: "DOU",
	},
	donphan: {
		tier: "UU",
		doublesTier: "DOU",
	},
	stantler: {
		tier: "RU",
		doublesTier: "DOU",
	},
	wyrdeer: {
		tier: "RU",
		doublesTier: "DOU",
	},
	tyranitar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pelipper: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gardevoir: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gallade: {
		tier: "RU",
		doublesTier: "DOU",
	},
	masquerain: {
		tier: "RU",
		doublesTier: "DOU",
	},
	breloom: {
		tier: "UU",
		doublesTier: "DOU",
	},
	slaking: {
		tier: "RU",
		doublesTier: "DOU",
	},
	hariyama: {
		tier: "UU",
		doublesTier: "DOU",
	},
	sableye: {
		tier: "RU",
		doublesTier: "DOU",
	},
	medicham: {
		tier: "RU",
		doublesTier: "DOU",
	},
	swalot: {
		tier: "RU",
		doublesTier: "DOU",
	},
	camerupt: {
		tier: "RU",
		doublesTier: "DOU",
	},
	torkoal: {
		tier: "UU",
		doublesTier: "DOU",
	},
	grumpig: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cacturne: {
		tier: "RU",
		doublesTier: "DOU",
	},
	altaria: {
		tier: "RU",
		doublesTier: "DOU",
	},
	zangoose: {
		tier: "RU",
		doublesTier: "DOU",
	},
	seviper: {
		tier: "RU",
		doublesTier: "DOU",
	},
	whiscash: {
		tier: "RU",
		doublesTier: "DOU",
	},
	banette: {
		tier: "RU",
		doublesTier: "DOU",
	},
	tropius: {
		tier: "RU",
		doublesTier: "DOU",
	},
	glalie: {
		tier: "RU",
		doublesTier: "DOU",
	},
	froslass: {
		tier: "UU",
		doublesTier: "DOU",
	},
	luvdisc: {
		tier: "RU",
		doublesTier: "DOU",
	},
	salamence: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kyogre: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	groudon: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	rayquaza: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	staraptor: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kricketune: {
		tier: "RU",
		doublesTier: "DOU",
	},
	luxray: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vespiquen: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pachirisu: {
		tier: "RU",
		doublesTier: "DOU",
	},
	floatzel: {
		tier: "UU",
		doublesTier: "DOU",
	},
	gastrodon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	drifblim: {
		tier: "RU",
		doublesTier: "DOU",
	},
	skuntank: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bronzong: {
		tier: "RU",
		doublesTier: "DOU",
	},
	spiritomb: {
		tier: "UU",
		doublesTier: "DOU",
	},
	garchomp: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lucario: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hippowdon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	toxicroak: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lumineon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	abomasnow: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rotom: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rotomheat: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rotomwash: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rotomfrost: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rotomfan: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rotommow: {
		tier: "RU",
		doublesTier: "DOU",
	},
	uxie: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mesprit: {
		tier: "RU",
		doublesTier: "DOU",
	},
	azelf: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dialga: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	dialgaorigin: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	palkia: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	palkiaorigin: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	heatran: {
		tier: "UU",
		doublesTier: "DOU",
	},
	giratina: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	giratinaorigin: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	cresselia: {
		tier: "UU",
		doublesTier: "DOU",
	},
	arceus: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	samurott: {
		tier: "RU",
		doublesTier: "DOU",
	},
	samurotthisui: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lilligant: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lilliganthisui: {
		tier: "UU",
		doublesTier: "DOU",
	},
	basculin: {
		tier: "RU",
		doublesTier: "DOU",
	},
	basculinbluestriped: {
		tier: "RU",
		doublesTier: "DOU",
	},
	basculegion: {
		tier: "OU",
		doublesTier: "DOU",
	},
	basculegionf: {
		tier: "UU",
		doublesTier: "DOU",
	},
	krookodile: {
		tier: "UU",
		doublesTier: "DOU",
	},
	zoroark: {
		tier: "RU",
		doublesTier: "DOU",
	},
	zoroarkhisui: {
		tier: "UU",
		doublesTier: "DOU",
	},
	gothitelle: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sawsbuck: {
		tier: "RU",
		doublesTier: "DOU",
	},
	amoonguss: {
		tier: "OU",
		doublesTier: "DOU",
	},
	alomomola: {
		tier: "OU",
		doublesTier: "DOU",
	},
	eelektross: {
		tier: "RU",
		doublesTier: "DOU",
	},
	haxorus: {
		tier: "UU",
		doublesTier: "DOU",
	},
	beartic: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cryogonal: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bisharp: {
		tier: "RU",
		doublesTier: "DOU",
	},
	kingambit: {
		tier: "OU",
		doublesTier: "DOU",
	},
	braviary: {
		tier: "RU",
		doublesTier: "DOU",
	},
	braviaryhisui: {
		tier: "RU",
		doublesTier: "DOU",
	},
	hydreigon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	volcarona: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tornadus: {
		tier: "RU",
		doublesTier: "DOU",
	},
	tornadustherian: {
		tier: "OU",
		doublesTier: "DOU",
	},
	thundurus: {
		tier: "OU",
		doublesTier: "DOU",
	},
	thundurustherian: {
		tier: "UU",
		doublesTier: "DOU",
	},
	landorus: {
		tier: "UU",
		doublesTier: "DOU",
	},
	landorustherian: {
		tier: "OU",
		doublesTier: "DOU",
	},
	meloetta: {
		tier: "UU",
		doublesTier: "DOU",
	},
	meloettapirouette: {
		tier: "OU",
		doublesTier: "DOU",
	},
	chesnaught: {
		tier: "UU",
		doublesTier: "DOU",
	},
	delphox: {
		tier: "UU",
		doublesTier: "DOU",
	},
	greninja: {
		tier: "OU",
		doublesTier: "DOU",
	},
	talonflame: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vivillon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pyroar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	florges: {
		tier: "UU",
		doublesTier: "DOU",
	},
	gogoat: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dragalge: {
		tier: "UU",
		doublesTier: "DOU",
	},
	clawitzer: {
		tier: "RU",
		doublesTier: "DOU",
	},
	hawlucha: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dedenne: {
		tier: "RU",
		doublesTier: "DOU",
	},
	carbink: {
		tier: "RU",
		doublesTier: "DOU",
	},
	goodra: {
		tier: "RU",
		doublesTier: "DOU",
	},
	goodrahisui: {
		tier: "UU",
		doublesTier: "DOU",
	},
	klefki: {
		tier: "RU",
		doublesTier: "DOU",
	},
	avalugg: {
		tier: "UU",
		doublesTier: "DOU",
	},
	avalugghisui: {
		tier: "RU",
		doublesTier: "DOU",
	},
	noivern: {
		tier: "RU",
		doublesTier: "DOU",
	},
	diancie: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hoopa: {
		tier: "RU",
		doublesTier: "DOU",
	},
	hoopaunbound: {
		tier: "UU",
		doublesTier: "DOU",
	},
	volcanion: {
		tier: "UU",
		doublesTier: "DOU",
	},
	decidueye: {
		tier: "UU",
		doublesTier: "DOU",
	},
	decidueyehisui: {
		tier: "UU",
		doublesTier: "DOU",
	},
	gumshoos: {
		tier: "RU",
		doublesTier: "DOU",
	},
	crabominable: {
		tier: "OU",
		doublesTier: "DOU",
	},
	oricorio: {
		tier: "UU",
		doublesTier: "DOU",
	},
	oricoriopompom: {
		tier: "UU",
		doublesTier: "DOU",
	},
	oricoriopau: {
		tier: "UU",
		doublesTier: "DOU",
	},
	oricoriosensu: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lycanroc: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lycanrocmidnight: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lycanrocdusk: {
		tier: "UU",
		doublesTier: "DOU",
	},
	toxapex: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mudsdale: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lurantis: {
		tier: "RU",
		doublesTier: "DOU",
	},
	salazzle: {
		tier: "RU",
		doublesTier: "DOU",
	},
	tsareena: {
		tier: "UU",
		doublesTier: "DOU",
	},
	oranguru: {
		tier: "RU",
		doublesTier: "DOU",
	},
	passimian: {
		tier: "RU",
		doublesTier: "DOU",
	},
	palossand: {
		tier: "RU",
		doublesTier: "DOU",
	},
	komala: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mimikyu: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bruxish: {
		tier: "RU",
		doublesTier: "DOU",
	},
	magearna: {
		tier: "OU",
		doublesTier: "DOU",
	},
	magearnaoriginal: {
		tier: "OU",
		doublesTier: "DOU",
	},
	rillaboom: {
		tier: "UU",
		doublesTier: "DOU",
	},
	cinderace: {
		tier: "OU",
		doublesTier: "DOU",
	},
	inteleon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	greedent: {
		tier: "RU",
		doublesTier: "DOU",
	},
	corviknight: {
		tier: "OU",
		doublesTier: "DOU",
	},
	drednaw: {
		tier: "RU",
		doublesTier: "DOU",
	},
	coalossal: {
		tier: "RU",
		doublesTier: "DOU",
	},
	flapple: {
		tier: "RU",
		doublesTier: "DOU",
	},
	appletun: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dipplin: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sandaconda: {
		tier: "RU",
		doublesTier: "DOU",
	},
	barraskewda: {
		tier: "UU",
		doublesTier: "DOU",
	},
	toxtricity: {
		tier: "RU",
		doublesTier: "DOU",
	},
	toxtricitylowkey: {
		tier: "RU",
		doublesTier: "DOU",
	},
	polteageist: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hatterene: {
		tier: "UU",
		doublesTier: "DOU",
	},
	grimmsnarl: {
		tier: "RU",
		doublesTier: "DOU",
	},
	falinks: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pincurchin: {
		tier: "RU",
		doublesTier: "DOU",
	},
	frosmoth: {
		tier: "RU",
		doublesTier: "DOU",
	},
	stonjourner: {
		tier: "RU",
		doublesTier: "DOU",
	},
	eiscue: {
		tier: "RU",
		doublesTier: "DOU",
	},
	indeedee: {
		tier: "UU",
		doublesTier: "DOU",
	},
	indeedeef: {
		tier: "RU",
		doublesTier: "DOU",
	},
	copperajah: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dragapult: {
		tier: "OU",
		doublesTier: "DOU",
	},
	zacian: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zaciancrowned: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zamazenta: {
		tier: "UU",
		doublesTier: "DOU",
	},
	zamazentacrowned: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	eternatus: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	urshifu: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	urshifurapidstrike: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zarude: {
		tier: "RU",
		doublesTier: "DOU",
	},
	regieleki: {
		tier: "RU",
		doublesTier: "DOU",
	},
	regidrago: {
		tier: "UU",
		doublesTier: "DOU",
	},
	glastrier: {
		tier: "RU",
		doublesTier: "DOU",
	},
	spectrier: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	calyrex: {
		tier: "RU",
		doublesTier: "DOU",
	},
	calyrexice: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	calyrexshadow: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	enamorus: {
		tier: "UU",
		doublesTier: "DOU",
	},
	enamorustherian: {
		tier: "UU",
		doublesTier: "DOU",
	},
	meowscarada: {
		tier: "OU",
		doublesTier: "DOU",
	},
	skeledirge: {
		tier: "UU",
		doublesTier: "DOU",
	},
	quaquaval: {
		tier: "UU",
		doublesTier: "DOU",
	},
	oinkologne: {
		tier: "RU",
		doublesTier: "DOU",
	},
	oinkolognef: {
		tier: "RU",
		doublesTier: "DOU",
	},
	spidops: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lokix: {
		tier: "UU",
		doublesTier: "DOU",
	},
	pawmot: {
		tier: "UU",
		doublesTier: "DOU",
	},
	maushold: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dachsbun: {
		tier: "RU",
		doublesTier: "DOU",
	},
	arboliva: {
		tier: "UU",
		doublesTier: "DOU",
	},
	squawkabilly: {
		tier: "RU",
		doublesTier: "DOU",
	},
	squawkabillyblue: {
		tier: "RU",
		doublesTier: "DOU",
	},
	squawkabillyyellow: {
		tier: "RU",
		doublesTier: "DOU",
	},
	squawkabillywhite: {
		tier: "RU",
		doublesTier: "DOU",
	},
	garganacl: {
		tier: "OU",
		doublesTier: "DOU",
	},
	armarouge: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ceruledge: {
		tier: "OU",
		doublesTier: "DOU",
	},
	bellibolt: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kilowattrel: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mabosstiff: {
		tier: "RU",
		doublesTier: "DOU",
	},
	grafaiai: {
		tier: "RU",
		doublesTier: "DOU",
	},
	brambleghast: {
		tier: "UU",
		doublesTier: "DOU",
	},
	toedscruel: {
		tier: "UU",
		doublesTier: "DOU",
	},
	klawf: {
		tier: "RU",
		doublesTier: "DOU",
	},
	scovillain: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rabsca: {
		tier: "RU",
		doublesTier: "DOU",
	},
	espathra: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tinkaton: {
		tier: "UU",
		doublesTier: "DOU",
	},
	wugtrio: {
		tier: "RU",
		doublesTier: "DOU",
	},
	bombirdier: {
		tier: "RU",
		doublesTier: "DOU",
	},
	palafin: {
		tier: "UU",
		doublesTier: "DOU",
	},
	revavroom: {
		tier: "UU",
		doublesTier: "DOU",
	},
	cyclizar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	orthworm: {
		tier: "UU",
		doublesTier: "DOU",
	},
	glimmora: {
		tier: "UU",
		doublesTier: "DOU",
	},
	houndstone: {
		tier: "RU",
		doublesTier: "DOU",
	},
	flamigo: {
		tier: "RU",
		doublesTier: "DOU",
	},
	cetitan: {
		tier: "RU",
		doublesTier: "DOU",
	},
	veluza: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dondozo: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tatsugiri: {
		tier: "RU",
		doublesTier: "DOU",
	},
	greattusk: {
		tier: "OU",
		doublesTier: "DOU",
	},
	screamtail: {
		tier: "UU",
		doublesTier: "DOU",
	},
	brutebonnet: {
		tier: "UU",
		doublesTier: "DOU",
	},
	fluttermane: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	slitherwing: {
		tier: "UU",
		doublesTier: "DOU",
	},
	sandyshocks: {
		tier: "UU",
		doublesTier: "DOU",
	},
	irontreads: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ironbundle: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	ironhands: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ironjugulis: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ironmoth: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ironthorns: {
		tier: "UU",
		doublesTier: "DOU",
	},
	baxcalibur: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gholdengo: {
		tier: "OU",
		doublesTier: "DOU",
	},
	wochien: {
		tier: "UU",
		doublesTier: "DOU",
	},
	chienpao: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	tinglu: {
		tier: "OU",
		doublesTier: "DOU",
	},
	chiyu: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	roaringmoon: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ironvaliant: {
		tier: "OU",
		doublesTier: "DOU",
	},
	koraidon: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	miraidon: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	walkingwake: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ironleaves: {
		tier: "UU",
		doublesTier: "DOU",
	},
	arbok: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sandslash: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sandslashalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	clefable: {
		tier: "UU",
		doublesTier: "DOU",
	},
	victreebel: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vulpix: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ninetales: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ninetalesalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	poilwrath: {
		tier: "RU",
		doublesTier: "DOU",
	},
	politoed: {
		tier: "UU",
		doublesTier: "DOU",
	},
	golem: {
		tier: "RU",
		doublesTier: "DOU",
	},
	golemalola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	weezing: {
		tier: "RU",
		doublesTier: "DOU",
	},
	weezinggalar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	snorlax: {
		tier: "UU",
		doublesTier: "DOU",
	},
	furret: {
		tier: "RU",
		doublesTier: "DOU",
	},
	noctowl: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ariados: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ambipom: {
		tier: "RU",
		doublesTier: "DOU",
	},
	yanmega: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gligar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	gliscor: {
		tier: "OU",
		doublesTier: "DOU",
	},
	magcargo: {
		tier: "RU",
		doublesTier: "DOU",
	},
	piloswine: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mamoswine: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mightyena: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ludicolo: {
		tier: "RU",
		doublesTier: "DOU",
	},
	shiftry: {
		tier: "RU",
		doublesTier: "DOU",
	},
	probopass: {
		tier: "RU",
		doublesTier: "DOU",
	},
	volbeat: {
		tier: "RU",
		doublesTier: "DOU",
	},
	illumise: {
		tier: "RU",
		doublesTier: "DOU",
	},
	crawdaunt: {
		tier: "UU",
		doublesTier: "DOU",
	},
	milotic: {
		tier: "OU",
		doublesTier: "DOU",
	},
	dusknoir: {
		tier: "RU",
		doublesTier: "DOU",
	},
	chimecho: {
		tier: "RU",
		doublesTier: "DOU",
	},
	jirachi: {
		tier: "UU",
		doublesTier: "DOU",
	},
	torterra: {
		tier: "RU",
		doublesTier: "DOU",
	},
	infernape: {
		tier: "UU",
		doublesTier: "DOU",
	},
	empoleon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	phione: {
		tier: "RU",
		doublesTier: "DOU",
	},
	manaphy: {
		tier: "UU",
		doublesTier: "DOU",
	},
	shaymin: {
		tier: "OU",
		doublesTier: "DOU",
	},
	shayminsky: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	darkrai: {
		tier: "OU",
		doublesTier: "DOU",
	},
	conkeldurr: {
		tier: "UU",
		doublesTier: "DOU",
	},
	leavanny: {
		tier: "RU",
		doublesTier: "DOU",
	},
	swanna: {
		tier: "RU",
		doublesTier: "DOU",
	},
	chandelure: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mienshao: {
		tier: "UU",
		doublesTier: "DOU",
	},
	mandibuzz: {
		tier: "UU",
		doublesTier: "DOU",
	},
	trevenant: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vikavolt: {
		tier: "RU",
		doublesTier: "DOU",
	},
	ribombee: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kommoo: {
		tier: "UU",
		doublesTier: "DOU",
	},
	cramorant: {
		tier: "RU",
		doublesTier: "DOU",
	},
	morpeko: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sinistcha: {
		tier: "UU",
		doublesTier: "DOU",
	},
	okidogi: {
		tier: "UU",
		doublesTier: "DOU",
	},
	munkidori: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	fezandipiti: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ogerpon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ogerponhearthflame: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ogerponcornerstone: {
		tier: "UU",
		doublesTier: "DOU",
	},
	ogerponwellspring: {
		tier: "OU",
		doublesTier: "DOU",
	},
	qwilfishhisui: {
		tier: "RU",
		doublesTier: "DOU",
	},
	hattrem: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	gabite: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	gurdurr: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	misdreavus: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	naclstack: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	pikachu: {
		tier: "RU",
		doublesTier: "DOU",
	},
	quaxwell: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	thwackey: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	poliwrath: {
		tier: "RU",
		doublesTier: "DOU",
	},
	tinkatuff: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	terapagos: {
		tier: "UU",
	},
	hydrapple: {
		tier: "UU",
	},
	ragingbolt: {
		tier: "OU",
	},
	gougingfire: {
		tier: "OU",
	},
	archaludon: {
		tier: "OU",
	},
	ironcrown: {
		tier: "OU",
	},
	ironboulder: {
		tier: "OU",
	},
	venusaur: {
		tier: "UU",
		doublesTier: "DOU",
	},
	blastoise: {
		tier: "UU",
		doublesTier: "DOU",
	},
	vileplume: {
		tier: "UU",
		doublesTier: "DOU",
	},
	bellossom: {
		tier: "UU",
		doublesTier: "DOU",
	},
	tentacruel: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dodrio: {
		tier: "UU",
		doublesTier: "DOU",
	},
	dewgong: {
		tier: "UU",
		doublesTier: "DOU",
	},
	exeggutor: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hitmonlee: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hitmonchan: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hitmontop: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rhydon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rhyperior: {
		tier: "UU",
		doublesTier: "DOU",
	},
	kingdra: {
		tier: "UU",
		doublesTier: "DOU",
	},
	electivire: {
		tier: "UU",
		doublesTier: "DOU",
	},
	magmortar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lapras: {
		tier: "UU",
		doublesTier: "DOU",
	},
	porygon2: {
		tier: "RU",
		doublesTier: "DOU",
	},
	porygonz: {
		tier: "UU",
		doublesTier: "DOU",
	},
	meganium: {
		tier: "UU",
		doublesTier: "DOU",
	},
	feraligatr: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lanturn: {
		tier: "UU",
		doublesTier: "DOU",
	},
	granbull: {
		tier: "UU",
		doublesTier: "DOU",
	},
	skarmory: {
		tier: "OU",
		doublesTier: "DOU",
	},
	smeargle: {
		tier: "UU",
		doublesTier: "DOU",
	},
	raikou: {
		tier: "UU",
		doublesTier: "DOU",
	},
	entei: {
		tier: "UU",
		doublesTier: "DOU",
	},
	suicune: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lugia: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	hooh: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	sceptile: {
		tier: "UU",
		doublesTier: "DOU",
	},
	combusken: {
		tier: "RU",
		doublesTier: "DOU",
	},
	blaziken: {
		tier: "OU",
		doublesTier: "DOU",
	},
	swampert: {
		tier: "UU",
		doublesTier: "DOU",
	},
	plusle: {
		tier: "UU",
		doublesTier: "DOU",
	},
	minun: {
		tier: "UU",
		doublesTier: "DOU",
	},
	flygon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	metagross: {
		tier: "UU",
		doublesTier: "DOU",
	},
	regirock: {
		tier: "UU",
		doublesTier: "DOU",
	},
	regice: {
		tier: "UU",
		doublesTier: "DOU",
	},
	registeel: {
		tier: "UU",
		doublesTier: "DOU",
	},
	regigigas: {
		tier: "OU",
		doublesTier: "DOU",
	},
	latias: {
		tier: "UU",
		doublesTier: "DOU",
	},
	latios: {
		tier: "UU",
		doublesTier: "DOU",
	},
	deoxys: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	deoxysattack: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	deoxysdefense: {
		tier: "UU",
		doublesTier: "DOU",
	},
	deoxysspeed: {
		tier: "OU",
		doublesTier: "DOU",
	},
	rampardos: {
		tier: "UU",
		doublesTier: "DOU",
	},
	bastiodon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	serperior: {
		tier: "UU",
		doublesTier: "DOU",
	},
	emboar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	zebstrika: {
		tier: "UU",
		doublesTier: "DOU",
	},
	excadrill: {
		tier: "UU",
		doublesTier: "DOU",
	},
	whimsicott: {
		tier: "UU",
		doublesTier: "DOU",
	},
	scrafty: {
		tier: "UU",
		doublesTier: "DOU",
	},
	cinccino: {
		tier: "UU",
		doublesTier: "DOU",
	},
	reuniclus: {
		tier: "UU",
		doublesTier: "DOU",
	},
	galvantula: {
		tier: "UU",
		doublesTier: "DOU",
	},
	golurk: {
		tier: "UU",
		doublesTier: "DOU",
	},
	cobalion: {
		tier: "UU",
		doublesTier: "DOU",
	},
	terrakion: {
		tier: "UU",
		doublesTier: "DOU",
	},
	virizion: {
		tier: "UU",
		doublesTier: "DOU",
	},
	reshiram: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zekrom: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	kyurem: {
		tier: "OU",
		doublesTier: "DOU",
	},
	kyuremblack: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	kyuremwhite: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	keldeo: {
		tier: "OU",
		doublesTier: "DOU",
	},
	meowstic: {
		tier: "UU",
		doublesTier: "DOU",
	},
	meowsticf: {
		tier: "UU",
		doublesTier: "DOU",
	},
	malamar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	incineroar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	primarina: {
		tier: "UU",
		doublesTier: "DOU",
	},
	toucannon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	araquanid: {
		tier: "UU",
		doublesTier: "DOU",
	},
	comfey: {
		tier: "UU",
		doublesTier: "DOU",
	},
	minior: {
		tier: "UU",
		doublesTier: "DOU",
	},
	cosmog: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	cosmoem: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	solgaleo: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	lunala: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	necrozma: {
		tier: "UU",
		doublesTier: "DOU",
	},
	necrozmaduskmane: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	necrozmadawnwings: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	alcremie: {
		tier: "UU",
		doublesTier: "DOU",
	},
	duraludon: {
		tier: "RU",
		doublesTier: "DOU",
	},
	exeggutoralola: {
		tier: "UU",
		doublesTier: "DOU",
	},
	revavroomcaph: {
		tier: "Illegal",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	revavroomnavi: {
		tier: "Illegal",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	revavroomruchbah: {
		tier: "Illegal",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	revavroomschedar: {
		tier: "Illegal",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	revavroomsegin: {
		tier: "Illegal",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
};
